export function isOnlyTherapist(user) {
    return (user?.isTherapist && !user?.isAdmin);
}